import React, { useState } from "react";
import { Link } from "react-router-dom";
import '../styles/BecomeaPartnerPlace.css';


const BecomeaPartnerPlace =()=> {
     const [activeIndex, setActiveIndex] = useState(null);
    
      const questions = [
        {
question: "What is the Berymo Partnership Program?",
answer:(
<ol className="faq-steps">
<p>
"At Berymo, we strive to differentiate ourselves from a food delivery service. Alternatively, we transport paying customers directly to your front door.
<br /><br />
We ask our partner places to encourage customers to use Berymo Places as their return ride to ensure customers safety and guest satisfaction."
</p>
</ol>
),
},
       
{
question: "How do the Platfrom works?",
answer:(
<ol className="faq-steps">
<p>
"Customers choose your place within the app and schedule a ride. The driver will pick up the customer and transport the customer to your place.
<br /><br />
In order for a customer to claim their free ride, the customer must scan the Berymo Code on their app provided by your place."
</p>
</ol>
),
},{
question: " How will Partnering with Berymo increase my revenue",
answer:(
<ol className="faq-steps">
<p>
 "Your place will be listed on the Berymo Places app. Every customer will be able to see your place, review your menu and specials, as well as, access customer ratings and reviews.
<br /><br />
Once a rider chooses your restaurant, they will request a free ride to your place. They will also have the option to request a return ride.
<br /><br />
Berymo does not charge a service fee if a customer fails to check in or if the customer does not meet the spending requirement."
</p>
</ol>
),
},
         {
          question: "How Much does Berymo charge for customer?",
          answer: "The service fee may change based on your required spending limit and/or your places location. We provide pricing options to fit your interests. Please contact your Berymo Places representative for more information regarding pricing options."
        },
       
      ];
    
      const toggleQuestion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
      };
      return(
        <>
        
          <div className="hero-sec">
        <div className="hero-text">
          <h1>Attract more<br />customers</h1>
          <p>Berymo brings customers right to your door.</p>
          <a href="https://place-sit.berymo.com/#/signup">
          <button className="rideess">Become a Partner place</button>
          </a>
        </div>
        <div className="all-images">
          <img src="/images/siva.jpg" alt="Hero" className="hero-image"/>
        </div>
      </div>
      
      
        
        <div className="berymo-containers">
                <h2>Why partner with Berymo Places</h2>
                <p className="berymo-subtexts">
                  On average, our partner places see a 225% increase on their sales in less than 6 weeks.
                </p>
                <div className="berymo-grids">
                  {[
                    { img: "smile", title: "Generate more incomes", text: "Berymo Places picks up customers and brings them right to your door. Customers dine in the comfort of your place with an inclination to spend more money." },
                    { img: "pie-chart", title: "Customer satisfaction", text: "When partnering with Berymo Places, users can see your place on the app, request a free ride, dine at your restaurant, and request a return ride." },
                    { img: "user", title: "Our responsibilities", text: "Our partner places are mindful of customers drinking and driving. As a partner with Berymo Places, your customers have a safe and return ride." }
                  ].map((item, i) => (
                    <div className="berymo-box" key={i}>
                      <img src={`/images/${item.img}.png`} alt={item.img} className="icon" />
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                      
                 
                    </div>
                    
                  )
                  )}
                </div>
              </div>

               <div className="place-image">
          <img src="/images/places-2.jpg" alt="place" />
        </div>

        {/* FAQ */}
      <div className="faq-sections">
        <h1>Frequently asked questions from our rider</h1>
        <div className="faq-lists">
          {questions.map((item, index) => (
  <div
    key={index}
    className="faq-items"
    onClick={() => toggleQuestion(index)}
  >
    <div className="faq-questions">
      <span>{item.question}</span>
      <span className="plus-icon">{activeIndex === index ? "×" : "+"}</span>
    </div>
    <div className={`faq-answers ${activeIndex === index ? 'open' : ''}`}>
      {item.answer}
    </div>
  </div>
))}

        </div>
      </div>

      
      <div className="signup-section">
      <h1>Get more customers</h1>
      <p>Berymo is the fastest way to bring more customers to your place</p>
      <a href="https://place-sit.berymo.com/#/signup">   
         <button className="ride">Become a Partner Place</button></a>
    </div>
        
       </>
      )

}

    export default BecomeaPartnerPlace;